import { Alert } from "flowbite-react";
import React from "react";
import { TfiAnnouncement } from "react-icons/tfi";
const DefaultAlert = ({
  color = "warning",
  heading = "",
  body = "",
  icon = "",
  close = false,
  removeClose = false
}) => {
  return (
    <Alert color={color} rounded
      // onDismiss={() => close}
      className={removeClose ? "removeClose w-full" : "w-full"}>
      <div className="flex flex-row items-center gap-2">
        <div className="w-12 rounded-full bg-white text-xl h-12 flex justify-center items-center">
          {icon ? icon : <TfiAnnouncement />}
        </div>
        <div className="flex flex-col flex-1 w-full">
          <span className="font-medium">{heading}</span>
          <span className="font-medium">{body}</span>
        </div>
      </div>

    </Alert>
  )
};

export default DefaultAlert;